var React = require('react');

function Save (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M13 11H31V34L22 27.0439L13 34V11Z","fill":"transparent","key":1}),React.createElement("path",{"d":"M13 11H31V34L22 27.0439L13 34V11ZM16 14V28L22 23.5L28 28V14H16Z","fill":"black","key":2})]);
}

Save.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Save;

Save.default = Save;
